<tui-data-list class="gatewee-nav-flyout">
  <!-- Section header: icon + title -->
  <header class="gatewee-nav-flyout__header">
    <span class="gatewee-nav-flyout__header-title">{{
      item.title | translate
    }}</span>
  </header>

  <tui-opt-group>
    <!-- Parent's own route — icon + title to mirror the header above -->
    <a
      *ngIf="item.route"
      tuiOption
      new
      class="gatewee-nav-flyout__parent-route"
      [routerLink]="item.route"
      (click)="optionSelected.emit()"
    >
      <span>{{ item.title | translate }}</span>
    </a>

    <ng-container *ngFor="let sub of item.subMenu">
      <!-- Case A: leaf sub-item — no sub-submenu -->
      <ng-container *ngIf="!sub.subsubMenu?.length && !sub.theme">
        <a
          *ngIf="sub.route && !sub.openInNewTab"
          tuiOption
          new
          [routerLink]="sub.route"
          (click)="optionSelected.emit()"
          >{{ sub.title | translate }}</a
        >
        <a
          *ngIf="sub.route && sub.openInNewTab"
          tuiOption
          new
          [attr.href]="externalHref(sub.route)"
          target="_blank"
          rel="noopener noreferrer"
          (click)="optionSelected.emit()"
          >{{ sub.title | translate }}</a
        >
      </ng-container>

      <!-- Case B: sub-item that has a third level — group with label -->
      <ng-container *ngIf="sub.subsubMenu?.length">
        <tui-opt-group>
          <div class="gatewee-nav-flyout__header">
            <span class="gatewee-nav-flyout__header-title">{{
              sub.title | translate
            }}</span>
          </div>

          <!-- Sub's own overview route (mirrors the split-row left side) -->
          <a
            *ngIf="sub.route && !sub.openInNewTab"
            tuiOption
            new
            [routerLink]="sub.route"
            (click)="optionSelected.emit()"
            >{{ sub.title | translate }}</a
          >
          <!-- Each sub-sub item -->
          <a
            *ngFor="let ss of sub.subsubMenu"
            tuiOption
            new
            [routerLink]="ss.route"
            (click)="optionSelected.emit()"
            >{{ ss.title | translate }}</a
          >
        </tui-opt-group>
      </ng-container>
    </ng-container>
  </tui-opt-group>
</tui-data-list>
